import { AuthenticationService } from "../services/authentication.service";
import { VaultService } from "../services/vault.service";

/**
 * class to share the authentication instance to other modules to consumes the its features.
 */
export class AuthSingleton {
    private static instance: AuthenticationService | undefined = undefined;
    private static vault: VaultService | any = undefined;
    static getInstance(vaultService?: VaultService): AuthenticationService {
      try {
      this.vault = vaultService;
      if (this.instance === undefined)
        this.instance =
          (this.vault && new AuthenticationService(this.vault)) || undefined;
      return this.instance as AuthenticationService;
    } catch (error) {
      throw new Error(error);
    }
    }
  }